import * as React from "react";

import { formatDate } from "app/utils/filters";
import BackOfficeAndSnapminLink from "app/components/BOComponents/BackOfficeAndSnapminLink";
import SnapminLink from "app/components/BOComponents/SnapminLink";
import { ColumnConfig } from "app/components/AppComponents/ConfigurableTable";
import { FraudStatusIcon } from "app/components/AppComponents/Fraud";

const columnConfigs: ColumnConfig[] = [
  {
    name: "Date",
    render: row => formatDate(row.created_at)
  },
  {
    name: "Email",
    render: row => (
      <BackOfficeAndSnapminLink
        backofficeUrl={`/snapscan/ops/users/${row.external_reference}/payments`}
        snapminUrl={row.snapmin_url}
      >
        {row.email}
      </BackOfficeAndSnapminLink>
    )
  },
  {
    name: "Fraud status",
    render: row => <FraudStatusIcon fraudStatus={row.fraud_status} />
  },
  {
    name: "Group",
    render: row => row.group
  },

  {
    name: "Snapmin",
    render: row => <SnapminLink snapminUrl={row.snapmin_url} />
  }
];

export default columnConfigs;
